import React from 'react';

import { InterContentStyles } from '../../styles';
import { getTitleCase } from '../../utils';

interface ChipProps {
  eventType: string;
}

const Chip: React.FC<ChipProps> = ({ eventType }) => {
  const getColorClasses = (eventType: string) => {
    switch (eventType.toLowerCase()) {
      case 'webinar':
        return 'bg-blue-100 !text-blue-500';
      case 'virtual':
        return 'bg-yellow-100 !text-orange-dark';
      case 'hybrid':
        return 'bg-lavender-100 !text-lavender-500';
      case 'onsite':
        return 'bg-green-100 !text-green-700';
      case 'series':
        return 'bg-gray-100 !text-neutral-b1';
      default:
        return 'bg-blue-100 !text-blue-500';
    }
  };

  return (
    <div className="py-2">
      <span
        className={`px-2 py-1 rounded-[4px] ${InterContentStyles} ${getColorClasses(
          eventType,
        )}`}
      >
        {getTitleCase(eventType)}
      </span>
    </div>
  );
};

export const EventTypeTemplate: any = ({
  value = 'virtual',
}: {
  value: string;
}) => {
  return <Chip eventType={value} />;
};
